import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotComics() {
  const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">最受读者欢迎的<strong>漫画作品</strong></p>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}